import { render } from "./CreateOrSignin.vue?vue&type=template&id=e501c0f4"
import script from "./CreateOrSignin.vue?vue&type=script&lang=js"
export * from "./CreateOrSignin.vue?vue&type=script&lang=js"

import "./CreateOrSignin.vue?vue&type=style&index=0&id=e501c0f4&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__